import React, { useEffect, useState } from "react";
import { Scales, CaretDown, CaretRight } from "@phosphor-icons/react";
import { useLegalAdmin } from "./useLegalAdmin";
import { LegalContactCard, LegalGoLiveBanner } from "./LegalContactCard";
import { LegalPagesManager } from "./LegalPagesManager";

export const LegalPagesSection = () => {
  const [open, setOpen] = useState(() => window.location.hash === "#legal-pages");
  const { data, error, reload } = useLegalAdmin(null);
  useEffect(() => {
    if (window.location.hash !== "#legal-pages") return undefined;
    const t = setTimeout(() => { document.getElementById("legal-pages")?.scrollIntoView({ behavior: "smooth", block: "start" }); }, 400);
    return () => { clearTimeout(t); };
  }, []);
  return (
    <section className="brut-card bg-white mb-6" id="legal-pages" data-testid="legal-pages-section">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="legal-pages-toggle"
              className="w-full px-4 py-3 flex items-center gap-2 text-left">
        <Scales size={18} weight="bold" />
        <span className="font-chivo font-black uppercase tracking-tighter">Legal pages &amp; disclaimers</span>
        <span className="label-mono text-zinc-600 hidden sm:inline">Privacy · Terms · Legal Partners · footer disclaimers</span>
        <span className="ml-auto">{open ? <CaretDown size={14} weight="bold" /> : <CaretRight size={14} weight="bold" />}</span>
      </button>
      {!open && data && <div className="px-4 pb-3"><LegalGoLiveBanner missing={data.contact.missing} testId="legal-golive-banner-collapsed" /></div>}
      {open && (
        <div className="px-4 pb-4 flex flex-col gap-4 border-t-2 border-black pt-4">
          {error && <div className="text-xs text-red-700" data-testid="legal-pages-error">Couldn't load the legal pages.</div>}
          {data && (
            <>
              <p className="text-[11px] text-zinc-600">
                These shared versions appear on every landing page. A buyer can have its own version (Buyers on the shared funnels → Legal),
                which replaces these on that buyer's links. Have your attorney review this wording before you rely on it.
              </p>
              <LegalContactCard contact={data.contact} canEdit={data.can_edit} onSaved={reload} />
              <LegalPagesManager data={data} pageId={null} onSaved={reload} />
            </>
          )}
        </div>
      )}
    </section>
  );
};
